var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"featured-icon",class:_vm.rootClassNames,style:(_vm.sizingProperties)},[_c('Icon',{staticClass:"featured-icon__icon",attrs:{"name":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }